import React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import { Paper } from '@mui/material';

import CustomFonts from './CustomFonts';
import CustomColour from './CustomColour';

const CustomTabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
};

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
};

const BrandManagement = ({ account, onRefresh }) => {
    const [tab, setTab] = React.useState(0);

    return (
        <Box sx={{ px: 2 }}>
            <Paper>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={tab} onChange={(e, value) => setTab(value)}>
                        <Tab label="Brand Fonts" />
                        <Tab label="Brand Colours" />
                    </Tabs>
                </Box>
                <CustomTabPanel value={tab} index={0}>
                    <CustomFonts account={account} onRefresh={onRefresh} />
                </CustomTabPanel>
                <CustomTabPanel value={tab} index={1}>
                    <CustomColour account={account} onRefresh={onRefresh} />
                </CustomTabPanel>
            </Paper>
        </Box>
    );
};

export default BrandManagement;